import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import Constant from "../Constant";
import { getAccessToken } from "../../hooks/AccessToken";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import "../../css/style.css";

class ManageMeetings extends Component {
  state = {
    meetingsList: [],
    pageNo: 1,
    totalMeetings: 0,
    loading: false,
    error: "",
    meetingNumber: "",
    passWord: "",
    sdkKey: "",
    sdkSecret: "",
    startTime: "",
    endTime: "",
    name: "",
    description: "",
    thumbnail: "",
    mobileImage: "",
    editingMeeting: null,
    showPopup: false,
    isMobile: window.innerWidth <= 768,
  };

  componentDidMount() {
    this.fetchMeetings();
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  fetchMeetings = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const token = getAccessToken();
      const response = await Axios.get(
        `${Constant.apiBasePath}meeting/get-all`,
        {
          headers: {
            token: token,
          },
        }
      );
      const { meetings } = response.data;
      const safeMeetings = Array.isArray(meetings) ? meetings : [];
      this.setState({
        meetingsList: safeMeetings,
        totalMeetings: safeMeetings.length,
        loading: false,
      });
    } catch (error) {
      console.error("Error fetching meetings:", error);
      this.setState({
        meetingsList: [],
        totalMeetings: 0,
        loading: false,
        error: "Unable to fetch meetings.",
      });
    }
  };

  togglePopup = (meeting = null) => {
    this.setState((prevState) => ({
      meetingNumber: meeting ? meeting.meetingNumber : "",
      passWord: meeting ? meeting.passWord : "",
      sdkKey: meeting ? meeting.sdkKey : "",
      sdkSecret: meeting ? meeting.sdkSecret : "",
      startTime: meeting ? meeting.startTime : "",
      endTime: meeting ? meeting.endTime : "",
      name: meeting ? meeting.name : "",
      description: meeting ? meeting.description : "",
      thumbnail: meeting ? meeting.thumbnail : "",
      mobileImage: meeting ? meeting.mobileImage : "",
      editingMeeting: meeting,
      showPopup: !prevState.showPopup,
    }));
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const token = getAccessToken();
        const formData = new FormData();
        formData.append("story", file);

        const response = await Axios.post(
          "https://api.storytent.in/api/story/uploadFileOnS3",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              token: token,
            },
          }
        );

        if (response.data.status === "Success") {
          this.setState({ thumbnail: response.data.location });
        } else {
          console.error("Error uploading thumbnail:", response.data.message);
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  };

  handleMobileImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const token = getAccessToken();
        const formData = new FormData();
        formData.append("mobileImage", file);

        const response = await Axios.post(
          `${Constant.apiBasePath}meeting/upload-mobile-image`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              token: token,
            },
          }
        );

        if (response.data.status === "Success") {
          this.setState({ mobileImage: response.data.location });
        } else {
          console.error("Error uploading mobile image:", response.data.message);
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  };

  addOrUpdateMeeting = async () => {
    try {
      const {
        meetingNumber,
        passWord,
        sdkKey,
        sdkSecret,
        startTime,
        endTime,
        name,
        description,
        thumbnail,
        mobileImage,
        editingMeeting,
      } = this.state;

      if (
        !meetingNumber.trim() ||
        !passWord.trim() ||
        !sdkKey.trim() ||
        !sdkSecret.trim() ||
        !startTime.trim() ||
        !endTime.trim() ||
        !name.trim() ||
        !description.trim() ||
        !thumbnail.trim()
      ) {
        alert("All fields are required");
        return;
      }

      const token = getAccessToken();
      let response;

      const meetingData = {
        meetingNumber,
        passWord,
        sdkKey,
        sdkSecret,
        startTime,
        endTime,
        name,
        description,
        thumbnail,
        mobileImage,
      };

      if (editingMeeting) {
        response = await Axios.put(
          `${Constant.apiBasePath}meeting/${editingMeeting._id}`,
          meetingData,
          { headers: { token: token } }
        );
      } else {
        response = await Axios.post(
          `${Constant.apiBasePath}meeting`,
          meetingData,
          { headers: { token: token } }
        );
      }

      const updatedMeeting = response.data?.updatedMeeting;
      const meeting = response.data?.meeting;

      if (updatedMeeting && updatedMeeting._id) {
        this.setState((prevState) => ({
          meetingsList: prevState.meetingsList.map((meeting) =>
            meeting._id === updatedMeeting._id ? updatedMeeting : meeting
          ),
          meetingNumber: "",
          passWord: "",
          sdkKey: "",
          sdkSecret: "",
          startTime: "",
          endTime: "",
          name: "",
          description: "",
          thumbnail: "",
          mobileImage: "",
          editingMeeting: null,
          showPopup: false,
        }));
      } else if (meeting && meeting._id) {
        this.setState((prevState) => ({
          meetingsList: [...prevState.meetingsList, meeting],
          totalMeetings: prevState.totalMeetings + 1,
          meetingNumber: "",
          passWord: "",
          sdkKey: "",
          sdkSecret: "",
          startTime: "",
          endTime: "",
          name: "",
          description: "",
          thumbnail: "",
          mobileImage: "",
          editingMeeting: null,
          showPopup: false,
        }));
      } else {
        console.error("Unexpected response format:", response.data);
      }
    } catch (error) {
      console.error("Error adding/updating meeting:", error);
    }
  };

  deleteMeeting = async (meetingId) => {
    try {
      const token = getAccessToken();
      const response = await Axios.delete(
        `${Constant.apiBasePath}meeting/${meetingId}`,
        { headers: { token: token } }
      );

      if (response.status === 200) {
        this.setState((prevState) => ({
          meetingsList: prevState.meetingsList.filter(
            (meeting) => meeting._id !== meetingId
          ),
          totalMeetings: Math.max(prevState.totalMeetings - 1, 0),
        }));
        alert("Meeting deleted successfully");
      } else {
        console.error("Failed to delete meeting:", response.data.message);
      }
    } catch (error) {
      console.error("Error deleting meeting:", error);
    }
  };

  toggleMeetingStatus = async (meetingId) => {
    try {
      const token = getAccessToken();
      const response = await Axios.post(
        `${Constant.apiBasePath}meeting/status/${meetingId}`,
        { meetingId },
        { headers: { token: token } }
      );

      const updatedMeeting = response.data?.meeting;
      if (updatedMeeting && updatedMeeting._id) {
        this.setState((prevState) => ({
          meetingsList: prevState.meetingsList.map((meeting) =>
            meeting._id === updatedMeeting._id ? updatedMeeting : meeting
          ),
        }));
      } else {
        this.fetchMeetings();
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  isMeetingActive = (status) => status === true || status === "true" || status === "active" || status === 1;

  formatTimelineParts = (value) => {
    if (!value) {
      return { date: "--", time: "--" };
    }

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      if (typeof value === "string") {
        const cleanValue = value.trim();
        const parts = cleanValue.split(/\s+/);
        if (parts.length > 1) {
          return {
            date: parts[0],
            time: parts.slice(1).join(" "),
          };
        }
        return { date: cleanValue, time: "--" };
      }
      return { date: String(value), time: "--" };
    }

    return {
      date: parsed.toLocaleDateString(),
      time: parsed.toLocaleTimeString(),
    };
  };

  getPopupContainerStyle = () => ({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: this.state.isMobile ? "center" : "center",
    padding: this.state.isMobile ? "10px" : "0",
    overflowY: this.state.isMobile ? "auto" : "visible",
    zIndex: 1000,
  });

  getPopupStyle = () => ({
    backgroundColor: "white",
    padding: this.state.isMobile ? "15px" : "20px",
    borderRadius: "10px",
    width: this.state.isMobile ? "100%" : "400px",
    maxWidth: this.state.isMobile ? "100%" : "400px",
    maxHeight: this.state.isMobile ? "80vh" : "80vh",
    overflow: "scroll",

    margin: this.state.isMobile ? "20px 0" : "0",
    fontSize: this.state.isMobile ? "14px" : "16px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  });

  getInputStyle = () => ({
    width: "100%",
    padding: this.state.isMobile ? "8px" : "10px",
    marginBottom: this.state.isMobile ? "8px" : "10px",
    borderRadius: "5px",
    border: "1px solid #ddd",
    fontSize: this.state.isMobile ? "14px" : "16px",
    boxSizing: "border-box",
  });

  getTextareaStyle = () => ({
    width: "100%",
    padding: this.state.isMobile ? "8px" : "10px",
    marginBottom: this.state.isMobile ? "8px" : "10px",
    borderRadius: "5px",
    border: "1px solid #ddd",
    height: this.state.isMobile ? "80px" : "100px",
    fontSize: this.state.isMobile ? "14px" : "16px",
    resize: "vertical",
    boxSizing: "border-box",
  });

  getButtonGroupStyle = () => ({
    marginTop: this.state.isMobile ? "15px" : "10px",
    display: "flex",
    gap: this.state.isMobile ? "8px" : "10px",
    flexDirection: this.state.isMobile ? "column" : "row",
  });

  getButtonStyle = (type) => ({
    padding: this.state.isMobile ? "10px 15px" : "8px 16px",
    fontSize: this.state.isMobile ? "14px" : "16px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    flex: this.state.isMobile ? "1" : "none",
    minHeight: this.state.isMobile ? "44px" : "auto", // Better touch target
  });

  render() {
    const {
      meetingsList,
      pageNo,
      totalMeetings,
      loading,
      error,
      showPopup,
      meetingNumber,
      passWord,
      sdkKey,
      sdkSecret,
      startTime,
      endTime,
      name,
      description,
      thumbnail,
      isMobile,
    } = this.state;
    const meetingsPerPage = Constant.perPage || 10;
    const totalCount = totalMeetings || meetingsList.length;
    const totalPages = Math.max(1, Math.ceil(totalCount / meetingsPerPage));
    const safePage = Math.min(pageNo, totalPages);
    const currentIndex = (safePage - 1) * meetingsPerPage;
    const currentMeetings = meetingsList.slice(
      currentIndex,
      currentIndex + meetingsPerPage
    );

    return (
      <div className="content-page contest-submissions-page contest-management-page openmic-consistent-page">
        <div className="content page-content-spaced">
          <div className="event-management-header">
            <div className="header-content">
              <div className="header-title">
                <h4 className="page-title-heading">Manage Meetings</h4>
                <p className="header-subtitle">
                  Configure meeting access, schedule, and live status.
                </p>
              </div>
              <div className="header-actions">
                <button
                  type="button"
                  className="btn btn-primary btn-add-event contest-add-match"
                  onClick={() => this.togglePopup()}
                >
                  + Add Meeting
                </button>
              </div>
            </div>
          </div>

          {showPopup && (
            <div style={this.getPopupContainerStyle()}>
              <div style={this.getPopupStyle()}>
                <h4
                  style={{
                    fontSize: isMobile ? "16px" : "18px",
                    marginBottom: isMobile ? "15px" : "20px",
                    textAlign: "center",
                  }}
                >
                  {this.state.editingMeeting ? "Edit Meeting" : "Add Meeting"}
                </h4>

                <input
                  type="text"
                  name="meetingNumber"
                  placeholder="Meeting Number"
                  value={meetingNumber}
                  onChange={this.handleInputChange}
                  style={this.getInputStyle()}
                />

                <input
                  type="text"
                  name="passWord"
                  placeholder="Password"
                  value={passWord}
                  onChange={this.handleInputChange}
                  style={this.getInputStyle()}
                />

                <input
                  type="text"
                  name="sdkKey"
                  placeholder="SDK Key"
                  value={sdkKey}
                  onChange={this.handleInputChange}
                  style={this.getInputStyle()}
                />

                <input
                  type="text"
                  name="sdkSecret"
                  placeholder="SDK Secret"
                  value={sdkSecret}
                  onChange={this.handleInputChange}
                  style={this.getInputStyle()}
                />

                <input
                  type="datetime-local"
                  name="startTime"
                  value={startTime}
                  onChange={this.handleInputChange}
                  style={this.getInputStyle()}
                />

                <input
                  type="datetime-local"
                  name="endTime"
                  value={endTime}
                  onChange={this.handleInputChange}
                  style={this.getInputStyle()}
                />

                <input
                  type="text"
                  name="name"
                  placeholder="Meeting Name"
                  value={name}
                  onChange={this.handleInputChange}
                  style={this.getInputStyle()}
                />

                <textarea
                  name="description"
                  placeholder="Meeting Description"
                  value={description}
                  onChange={this.handleInputChange}
                  style={this.getTextareaStyle()}
                />

                <input
                  type="file"
                  name="thumbnail"
                  accept="image/*"
                  onChange={this.handleFileChange}
                  style={this.getInputStyle()}
                />

                {thumbnail && (
                  <div
                    style={{
                      marginBottom: isMobile ? "10px" : "15px",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={thumbnail}
                      alt="Thumbnail"
                      style={{
                        maxWidth: "100%",
                        maxHeight: isMobile ? "150px" : "200px",
                        borderRadius: "5px",
                        border: "1px solid #ddd",
                      }}
                    />
                  </div>
                )}

                <input
                  type="file"
                  name="mobileImage"
                  accept="image/*"
                  onChange={this.handleMobileImageChange}
                  style={this.getInputStyle()}
                />

                {this.state.mobileImage && (
                  <div
                    style={{
                      marginBottom: isMobile ? "10px" : "15px",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={this.state.mobileImage}
                      alt="Mobile"
                      style={{
                        maxWidth: "100%",
                        maxHeight: isMobile ? "150px" : "200px",
                        borderRadius: "5px",
                        border: "1px solid #ddd",
                      }}
                    />
                  </div>
                )}

                <div style={this.getButtonGroupStyle()}>
                  <button
                    className="btn btn-success"
                    onClick={this.addOrUpdateMeeting}
                    style={this.getButtonStyle("success")}
                  >
                    Save
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => this.togglePopup()}
                    style={this.getButtonStyle("danger")}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="event-management-body">
            <div className="card contest-submissions-card contest-like-card">
              <div className="card-body">
                {error && <div className="alert alert-danger">{error}</div>}

                <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                  <table className="table event-table contest-submissions-table contest-like-table">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Meeting No</th>
                        <th>Name</th>
                        <th className="contest-timeline-col meeting-timeline-col">Timeline</th>
                        <th className="meeting-credentials-col">Credentials</th>
                        <th className="meeting-media-col">Thumbnail</th>
                        <th className="meeting-media-col">Mobile Image</th>
                        <th className="contest-status-col">Status</th>
                        <th className="actions-col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="9" className="table-loading-cell">
                            Loading meetings...
                          </td>
                        </tr>
                      ) : currentMeetings.length === 0 ? (
                        <tr>
                          <td colSpan="9" className="table-loading-cell">
                            No meetings found.
                          </td>
                        </tr>
                      ) : (
                        currentMeetings.map((meeting, index) => {
                          const isActive = this.isMeetingActive(meeting.status);
                          const startTimeline = this.formatTimelineParts(meeting.startTime);
                          const endTimeline = this.formatTimelineParts(meeting.endTime);
                          return (
                            <tr key={meeting._id || index} className="table-row">
                              <td>{currentIndex + index + 1}</td>
                              <td>{meeting.meetingNumber || "--"}</td>
                              <td>{meeting.name || "--"}</td>
                              <td className="contest-timeline-col meeting-timeline-col">
                                <div className="timeline-item meeting-timeline-item">
                                  <span>START</span>
                                  <div className="meeting-timeline-value">
                                    <strong>{startTimeline.date}</strong>
                                    <span className="meeting-timeline-time">
                                       {startTimeline.time}
                                    </span>
                                  </div>
                                </div>
                                <div className="timeline-item meeting-timeline-item">
                                  <span>CLOSE</span>
                                  <div className="meeting-timeline-value">
                                    <strong className="timeline-close">{endTimeline.date}</strong>
                                    <span className="meeting-timeline-time timeline-close">
                                       {endTimeline.time}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td className="meeting-credentials-col">
                                <div className="meeting-credentials-wrap">
                                  <div className="meeting-credentials-line">
                                    <strong>SDK Key:</strong> {meeting.sdkKey || "--"}
                                  </div>
                                  <div className="meeting-credentials-line">
                                    <strong>SDK Secret:</strong> {meeting.sdkSecret || "--"}
                                  </div>
                                  <div className="meeting-credentials-line">
                                    <strong>Password:</strong> {meeting.passWord || "--"}
                                  </div>
                                </div>
                              </td>
                              <td className="meeting-media-col">
                                {meeting.thumbnail ? (
                                  <img
                                    src={meeting.thumbnail}
                                    alt="Thumbnail"
                                    className="meeting-media-thumb"
                                  />
                                ) : (
                                  <span>--</span>
                                )}
                              </td>
                              <td className="meeting-media-col">
                                {meeting.mobileImage ? (
                                  <img
                                    src={meeting.mobileImage}
                                    alt="Mobile"
                                    className="meeting-media-thumb"
                                  />
                                ) : (
                                  <span>--</span>
                                )}
                              </td>
                              <td className="contest-status-col">
                                <button
                                  type="button"
                                  className={`contest-status-pill ${
                                    isActive ? "is-active" : "is-inactive"
                                  }`}
                                  onClick={() => this.toggleMeetingStatus(meeting._id)}
                                  style={{ border: 0, cursor: "pointer" }}
                                >
                                  {isActive ? "ACTIVE" : "INACTIVE"}
                                </button>
                              </td>
                              <td className="actions-col">
                                <button
                                  type="button"
                                  className="contest-icon-btn open-sessions-icon-btn"
                                  onClick={() => this.togglePopup(meeting)}
                                  aria-label="Edit meeting"
                                >
                                  <FontAwesomeIcon icon={faEdit} style={{ fontSize: "13px" }} />
                                </button>
                                <button
                                  type="button"
                                  className="contest-icon-btn open-sessions-icon-btn danger"
                                  onClick={() => this.deleteMeeting(meeting._id)}
                                  aria-label="Delete meeting"
                                >
                                  <FontAwesomeIcon
                                    icon={faTrashAlt}
                                    style={{ fontSize: "13px" }}
                                  />
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="pagination">
                  <button
                    type="button"
                    className={safePage === 1 ? "disabled" : "paginate-link"}
                    disabled={safePage === 1}
                    onClick={() => this.setState({ pageNo: safePage - 1 })}
                  >
                    Previous
                  </button>
                  <button type="button" className="page-number">
                    {safePage}/{totalPages}
                  </button>
                  <button
                    type="button"
                    className={
                      safePage === totalPages
                        ? "disabled"
                        : "paginate-link active"
                    }
                    disabled={safePage === totalPages}
                    onClick={() => this.setState({ pageNo: safePage + 1 })}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ManageMeetings);
